import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from '@tanstack/react-router';

import ResetForm from '@/components/organism/ResetPassword/ResetForm';
import { useAppDispatch } from '@/store';
import { selectAuthStatus, selectAuthError } from '@/store/selectors/auth';
import { forgotPasswordThunk } from '@/store/thunks/auth/forgotPasswordThunk';

export default function ResetPassword(): JSX.Element {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const authStatus = useSelector(selectAuthStatus);
  const error = useSelector(selectAuthError);
  const loading = authStatus === 'loading';

  const handleSubmit = useCallback(
    async (values: { emailAddress: string }) => {
      try {
        await dispatch(forgotPasswordThunk({ emailAddress: values.emailAddress })).unwrap();
        void navigate({ to: '/reset-password' });
      } catch {
        // Error handled via Redux state
      }
    },
    [dispatch, navigate]
  );

  return <ResetForm onSubmit={handleSubmit} loading={loading} error={error} />;
}
